import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";
import { useGetCentralInventoryCampusSideQuery } from "../../store/api";

export default function CampusRequestModal({
  open,
  onClose,
  onSubmit,
  mode = "add",
  initialValue = {},
  isLoading = false,
}) {
  const [centralCampusInventoryItemId, setCentralCampusInventoryItemId] = useState("");
  const [requestedQty, setRequestedQty] = useState("");

  const { data: inventoryData, isLoading: isInventoryLoading } = useGetCentralInventoryCampusSideQuery(undefined, {
    skip: !open,
  });

  const itemOptions = (inventoryData?.data?.items || []).map((item) => ({
    label: item.itemName,
    value: item.id,
  }));

  useEffect(() => {
    if (open) {
      setCentralCampusInventoryItemId(mode === "edit" ? initialValue?.centralCampusInventoryItemId || "" : "");
      setRequestedQty(mode === "edit" ? initialValue?.requestedQty || "" : "");
    } else {
      setCentralCampusInventoryItemId("");
      setRequestedQty("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, mode]);

  async function handleSubmit() {
    if (!centralCampusInventoryItemId.trim() || !requestedQty || isLoading) return;
    
    const qty = Number(requestedQty);
    if (qty <= 0) return;

    try {
      await onSubmit?.({
        centralCampusInventoryItemId,
        requestedQty: qty,
      });
    } catch (error) {
      console.error(error);
    }
  }

  const title = mode === "edit" ? "Edit Campus Request" : "Initialize Request";
  const buttonText = mode === "edit" ? "Save Changes" : "Initialize Request";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[503px] pt-6 pb-11 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-4 px-9">
          <div>
            <p className="text-xl leading-6 text-black font-bold">{title}</p>
            <p className="text-sm leading-4 text-black">Request Management</p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-10 px-9 space-y-4">
          <div>
            <label className="block text-sm leading-6 text-black">Central Item</label>
            <div className="mt-2 flex items-center bg-[#F2F2F2] px-2.5 py-3 rounded-[5px] border border-transparent">
              <select
                value={centralCampusInventoryItemId}
                onChange={(e) => setCentralCampusInventoryItemId(e.target.value)}
                className={`w-full bg-transparent text-sm outline-none ${!centralCampusInventoryItemId ? "text-[#A2A1A8]" : "text-black"}`}
              >
                <option value="" disabled>
                  {isInventoryLoading ? "Loading items..." : "Select item..."}
                </option>
                {itemOptions.map((opt) => (
                  <option key={opt.value} value={opt.value} className="text-black">
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <Input
            type="number"
            label="Requested Quantity"
            value={requestedQty}
            onChange={(e) => setRequestedQty(e.target.value)}
            min="1"
            placeholder="Enter Quantity"
          />

          <div className="mt-6">
            <button
              onClick={handleSubmit}
              disabled={isLoading || !centralCampusInventoryItemId || !requestedQty || Number(requestedQty) <= 0}
              className="w-full bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading && <Loader />}
              {isLoading ? "Processing..." : buttonText}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
